// extracted by mini-css-extract-plugin
export var bodyText = "more-card-module--bodyText--4b2cf";
export var button = "more-card-module--button--9b5bc";
export var buttonContainer = "more-card-module--buttonContainer--4decd";
export var contentContainer = "more-card-module--contentContainer--270c8";
export var eyebrow = "more-card-module--eyebrow--09d30";
export var hasForm = "more-card-module--hasForm--df91b";
export var icon = "more-card-module--icon--42580";
export var innerCard = "more-card-module--innerCard--c74c0";
export var moreCard = "more-card-module--moreCard--5da9d";
export var moreLink = "more-card-module--moreLink--99500";